module.exports = __webpack_public_path__ + "img/painmedicslogo-old.166db348.png";